export const fonts = {
  roboto: { value: `'Roboto Mono Variable', monospace` },
  space: { value: `'Space Mono', monospace` },
} as const;

export const fontWeights = {
  light: { value: 100 },
  regular: { value: 400 },
  medium: { value: 500 },
  bold: { value: 700 },
} as const;

export const fontSizes = {
  xs: { value: '12px' },
  sm: { value: '14px' },
  md: { value: '16px' },
  lg: { value: '18px' },
  xl: { value: '20px' },
  screenSm: { value: 'var(--font-size-small)' },
  screenStd: { value: 'var(--font-size-standard)' },
  screenMed: { value: 'var(--font-size-medium)' },
  screenLg: { value: 'var(--font-size-large)' },
} as const;

export const fontVariables = {
  '--font-size-small': '12px',
  '--font-size-standard': '14px',
  '--font-size-medium': '16px',
  '--font-size-large': '18px',
};

export const fontVariables4k = {
  '--font-size-small': '14px',
  '--font-size-standard': '16px',
  '--font-size-medium': '18px',
  '--font-size-large': '20px',
};
